module.exports = __webpack_public_path__ + "media/images/icons/book-e6e8d40cc4896d583a9e82a31c1462a9.svg";